import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { CloseDialogButton } from "./closeButtonDialog";
import { CustomFooter } from "./customFooter";
import { FundsTabs } from "components/pages";
import { useDeleteTenantPrivateBenchmarks } from "hooks/use-delete-tenant-private-benchmark";
import { language } from "language/default";
import { closeDialog } from "store/messages-dialog";
export const InsResetBenchmarkDialogAction = () => {
    const dispatch = useDispatch();
    const [, deleteMutation] = useDeleteTenantPrivateBenchmarks(), fundsPage = useSelector((state) => state.mainGridSettings, isEqual);
    const withInvestors = fundsPage.setFundTab === FundsTabs.InvestorAccounts;
    const stateId = withInvestors ? "all-InvestorAccount-grid" : "all-funds-grid";
    const selectedRows = useSelector((state) => state.grids.state[stateId]?.selectedRows);
    return React.createElement(CustomFooter, null,
        React.createElement(AuxButton, { label: language.en.common.yes, key: "main-delete-button", type: AuxButtonTypeEnum.DESTRUCTIVE_PRIMARY, onClick: () => {
                batch(() => {
                    if (selectedRows?.length) {
                        const deleteRequest = {
                            fundInvestorPair: selectedRows?.map((item) => {
                                const [fund, investor] = item.split("-");
                                return { fundId: fund, investorId: investor };
                            })
                        };
                        deleteMutation(deleteRequest, {});
                    }
                    dispatch(closeDialog());
                });
            } }),
        React.createElement(CloseDialogButton, { label: language.en.common.no }));
};
